/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Termsofuse_Description2Inputs */

const he_seo_termsofuse_description2 = /** @type {(inputs: Seo_Termsofuse_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קראו את תנאי השימוש של שירות מעקב המחירים Pricedrop.`)
};

const en_seo_termsofuse_description2 = /** @type {(inputs: Seo_Termsofuse_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the terms of use for the Pricedrop price tracking service.`)
};

/**
* | output |
* | --- |
* | "Read the terms of use for the Pricedrop price tracking service." |
*
* @param {Seo_Termsofuse_Description2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const seo_termsofuse_description2 = /** @type {((inputs?: Seo_Termsofuse_Description2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Termsofuse_Description2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_termsofuse_description2(inputs)
	return en_seo_termsofuse_description2(inputs)
});
export { seo_termsofuse_description2 as "seo_termsOfUse_description" }